import { UpdateEligibilityContextInputV2 } from '../../../../../graphql';
import { Insurer } from '@getvim-os/standard';
import gql from 'graphql-tag';
import { gqlClient } from '../../../gql-client';
import { logger } from '@getvim/vim-connect-logger';

const eligibilityContextLogger = logger.scope('Eligibility Context queries');

const UPDATE_ELIGIBILITY_CONTEXT_QUERY = gql`
  query UpdateEligibilityContextV2($input: UpdateEligibilityContextInputV2!) {
    updateEligibilityContextV2(input: $input) {
      transactionId
    }
  }
`;

export const getUpdateEligibilityContextInputV2 = (
  memberToken: string,
  provider: UpdateEligibilityContextInputV2['selectedProvider'],
  encounterId: string,
): UpdateEligibilityContextInputV2 => {
  return {
    encounterId,
    selectedProvider: {
      npi: provider.npi,
      firstName: provider.firstName,
      lastName: provider.lastName,
    },
    encryptedPatientDetails: {
      encryptedIdentifyInput: memberToken,
    },
  };
};

export const updateEligibilityContextV2 = async (
  input: UpdateEligibilityContextInputV2,
  insurer?: Insurer,
): Promise<string | undefined> => {
  try {
    const { data } = await gqlClient.query({
      query: UPDATE_ELIGIBILITY_CONTEXT_QUERY,
      variables: { input },
      fetchPolicy: 'no-cache',
      context: {
        uri: '/prior-auth/api/graphql',
        headers: {
          'x-insurer': insurer,
        },
      },
    });

    return data?.updateEligibilityContextV2?.transactionId;
  } catch (error) {
    eligibilityContextLogger.error('Failed to update eligibility', { error });
  }
};
